// src/pages/Auth/ConfirmEmail.tsx
import { useEffect, useState } from 'react';
import { Result, Button, Spin, Typography } from 'antd';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useStore } from '../../stores/root-store-context';

type State = 'loading' | 'success' | 'already' | 'error';

function getRawQueryParam(search: string, key: string): string {
    if (!search) return '';
    const escKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // ескейп для RegExp
    const m = search.match(new RegExp(`[?&]${escKey}=([^&#]*)`));
    return m?.[1] ?? '';
  }

export default function ConfirmEmail() {
  const [state, setState] = useState<State>('loading');
  const [errorText, setErrorText] = useState<string>('');
  const { search } = useLocation();
  const navigate = useNavigate();
  const {applicationStore} = useStore();

  useEffect(() => {
  const rawUserId = getRawQueryParam(search, 'userId');
  const rawCode   = getRawQueryParam(search, 'code');

  if (!rawUserId || !rawCode) {
    setState('error');
    setErrorText('Missing confirmation parameters.');
    return;
  }

  (async () => {
    try {
      await applicationStore.confirmEmail(rawUserId, rawCode);
      setState('success');
    } catch (err: any) {
      const msg = err?.response?.data || 'Confirmation failed.';
      setErrorText(typeof msg === 'string' ? msg : 'Confirmation failed.');
      if (msg?.toString().toLowerCase().includes('already')) setState('already');
      else setState('error');
    }
  })();
}, [search]);

  if (state === 'loading') {
    return (
      <div className="flex items-center justify-center h-[60vh]">
        <div className="text-center">
          <Spin size="large" />
          <div style={{ marginTop: 16 }}>Confirming your email…</div>
        </div>
      </div>
    );
  }

  const goLogin = () => navigate('/login');
  const goHome = () => navigate('/');

  if (state === 'success') {
    return (
      <Result
        status="success"
        title="Email confirmed!"
        subTitle="Your account was confirmed successfully."
        extra={[
          <Button type="primary" key="login" onClick={goLogin}>Sign in</Button>,
          <Button key="home" onClick={goHome}>Go to Home</Button>,
        ]}
      />
    );
  }

  if (state === 'already') {
    return (
      <Result
        status="info"
        title="Email already confirmed"
        subTitle="You can sign in to your account."
        extra={[
          <Button type="primary" key="login" onClick={goLogin}>Sign in</Button>,
          <Button key="home" onClick={goHome}>Go to Home</Button>,
        ]}
      />
    );
  }

  return (
    <Result
      status="error"
      title="Confirmation failed"
      subTitle={<Typography.Text>{errorText}</Typography.Text>}
      extra={[
        <Button key="home" onClick={goHome}>Go to Home</Button>,
      ]}
    />
  );
}
